import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';

import { ArangoService } from '../../services/arangoservice/arango.service';
import { Observable, of, Subscription } from 'rxjs';
import { Person } from '../../bo9-shared/models/person/person.model';
import { validationMessages } from '../../helpers/form.helper';
import { contactFullName } from '../../bo9-shared/models/contact/contact.model';
import { Invite } from '../../bo9-shared/models/person/invite.model';
import { MatTableDataSource} from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator} from '@angular/material/paginator';
import { PaneType } from '../../displayComponents/slide-panel/slide-panel.component';

export interface Relations {
  from: string,
  to: string,
  email: string,
  Invite: string,
  pearlmodule: string,
  naturalnumber: string,
  source: string
}
@Component({
    selector: 'app-relations',
    templateUrl: './relations.component.html',
    styleUrls: ['./relations.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RelationsComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public displayedColumns = ['from','to',  'email', 'relation', 'naturalnumber','source'];
  public dataSource = new MatTableDataSource<Relations>();
  messagesLoading$: Observable<boolean>;

  currentPane:PaneType = PaneType.center;
  valid: false;

  directionLinks: boolean = true;
  autoHide: boolean = false;
  responsive: boolean = true;

  searchString: string;

  currentP$: Observable<Person>;
  currentPerson: Person;
  InviteForm: FormGroup;
  user: Person;
  invites: Relations[] =[];

  validationMessages = validationMessages;

  Invites$: Observable<Invite[]>;
  PearlModuleTypes$: Observable<string[]>;
  subscriptions: Subscription[] = [];
  constructor(
    private auth: AuthService,
    private router: Router,
    private arangoService: ArangoService

    ) 
  {
    this.currentPane = PaneType.center;
    this.user = this.auth.getAuthUser()!;
    this.subscriptions.push(this.arangoService.recordVisit({
      page: this.router.url, component: 'RelationsComponent', 
      visitor: this.user._key,
      help: false
    }).subscribe ({next: () => {}})); 
    if (!this.user) {
      console.error('User Not logged in ');
      alert('EMail support&#64;bodyof9.com - Permission  Error #030'); 
      this.router.navigate(['login'] );
    } 
  }

  
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }


  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

  }

  ngOnInit() {

  }

  onPageChange(event:any){
    console.log(event);
  }


  onCloseClick() {
    this.currentPane = PaneType.center;
  }



  onClickExpand(p:Person) {
    console.log('Expand Person  Contact '+ JSON.stringify(p.contact));
    this.currentP$ = of(p);

    this.currentPane = PaneType.right;
  }

  personSubmittedHandler($event: any) {
    console.log(' Person  submitted '+ JSON.stringify($event));
    this.currentPane = PaneType.center;
  }

  relateSubmittedHandler($event: any) {
    console.log(' Relate  submitted '+ JSON.stringify($event));
    this.currentPane = PaneType.center;
  }

}
